import { SystemEventTypeEnum } from '@libs/types';
import { eventBus } from '@libs/utils';
import React, { useEffect, useRef, useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import styles from './ToastBar.module.css';

const widgetUid = 'ToastBar';
export const ToastBar = () => {
    const timerId = useRef(0);
    const [toastMessage, setToastMessage] = useState('');

    const close = () => {
        clearTimeout(timerId.current);
        timerId.current = 0;
        setToastMessage('');
    };

    useEffect(() => {
        eventBus.subscribe(SystemEventTypeEnum.TOAST_MESSAGE, widgetUid, (message) => {
            setToastMessage(message as unknown as string);
        });
        if (toastMessage) {
            if (timerId.current) {
                return;
            }
            timerId.current = setTimeout(close, 2500) as unknown as number;
        }
        return () => {
            clearTimeout(timerId.current);
            eventBus.unsubscribe(SystemEventTypeEnum.TOAST_MESSAGE, widgetUid);
        };
    }, [toastMessage]);

    const onSwipe = useSwipeable({
        onSwipedUp: () => close(),
        trackTouch: true,
    });

    if (!toastMessage) {
        return null;
    }

    return (
        <div data-test="toastBar" className={styles.toastBar}>
            <div className={styles.toastBarInner}>
                <div className={styles.toastBarContent} {...onSwipe} data-testid={widgetUid} onClick={close}>
                    {toastMessage}
                </div>
            </div>
        </div>
    );
};
